import React, { Fragment, useState } from 'react';
import './Form.scss';
import { useContext } from 'react';
import { uiContext } from '../common';
import { useHistory } from 'react-router-dom';

import {API} from '../../services/api'

const FormPage = () => {
    /**
     * Componente Formulario de Registro para usuarios nuevos
     * Vista para registrar un nuevo usuario
     */
    const uicontext = useContext(uiContext);
    const history = useHistory();
    const [radioButtonOption, SetRadioButtonOption] = useState(0);

    const [name, setName] = useState("");
    const [lastName, setLastName] = useState("");
    const [RUT, setRUT] = useState("");
    const [email, setEmail] = useState("");
    const [cellphone, setCellphone] = useState("");
    const [secondaryKey, setSecondaryKey] = useState("");
    const [message, setMessage] = useState("");

    const [showRegisterModal, setShowRegisterModal] = useState(false);
    const [showExistUserModal, setShowExistUserModal] = useState(false);

    const send = () => {
        let getTypeName = () => {
            switch (radioButtonOption) {
                case 0: return "FISHER";
                case 1: return "MARKETER";
                case 2: return "ORGANIZATION";
                default: return "ERROR";
            }            
        }

        uicontext.showLoader();
        /**
         * Verifica si el email existe
         * Se hace el llamado al servicio /users/verify-if-email-exists
         */
        API.putVerifyIfEmailExists(email)
            .then(x =>{
                if(x.length != 0){
                    uicontext.hideLoader();
                    setShowExistUserModal(true);
                    return;
                }
                /**
                 * Registra un usuario
                 * Se hace el llamado al servicio /users/register-user
                 */
                API.postRegisterUser({
                    name: name,
                    lastname: lastName,
                    rut: RUT,
                    email: email,
                    phone: cellphone,
                    type: getTypeName(),
                    typeKey: secondaryKey,
                    message
                })
                    .then(x => {
                        setShowRegisterModal(true);
                        uicontext.hideLoader();
                    })
                    .catch(x => {
                        uicontext.hideLoader();
                    });
            })
            .catch(x =>{
                uicontext.hideLoader();
            })
        
    }

    const validarRut = (rutCompleto) => {
        /*
        const dv = (T) => {
            var M = 0, S = 1;
            for (; T; T = Math.floor(T / 10))
                S = (S + T % 10 * (9 - M++ % 6)) % 11;
            return S ? S - 1 : 'k';
        }*/

        if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto))
            return false;
            /*
        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];
        if (digv === 'K') digv = 'k';
        return (dv(rut) === digv);*/
        return true;
    }

    const goToLogin = () => {
        history.push("/login");
    }

    return (
        <Fragment>
            <div className="formPageMasterContainer">
                <div onClick={() => { goToLogin(); }} className={(showRegisterModal === true ? "registerModalBackgroundVisible" : "registerModalBackgroundHidden") + " registerModalBackground"}></div>
                <div className={(showRegisterModal === true ? "registerModalVisible" : "registerModalHidden") + " registerModal"}>
                    <div className="blueCenterDiv">
                        <span className="modalTitle">Muchas gracias por su registro</span>
                        <span onClick={() => { goToLogin(); }} className="closeButton">X</span>
                    </div>
                    <div className="centerDiv whiteCenterDiv">
                        <span className="modalContent" >Una vez revisada la información ingresada, se le enviara un correo electrónico con los datos de acceso.</span>
                    </div>
                </div>

                <div onClick={() => { setShowExistUserModal(false); setEmail(""); }} className={(showExistUserModal === true ? "registerModalBackgroundVisible" : "registerModalBackgroundHidden") + " registerModalBackground"}></div>
                <div className={(showExistUserModal === true ? "registerModalVisible" : "registerModalHidden") + " registerModal"}>
                    <div className="blueCenterDiv">
                        <span className="modalTitle">Usuario existente</span>
                        <span onClick={() => { setShowExistUserModal(false); setEmail(""); }} className="closeButton">X</span>
                    </div>
                    <div className="centerDiv whiteCenterDiv">
                        <span className="modalContent" >El correo electrónico introducido ya ha sido registrado.</span>
                    </div>
                </div>
                <div className="formContainer">
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        e.stopPropagation(); send();
                    }} >
                        <div className="itemBase item100">
                            <h1>Solicita tu inscripción al programa de Caleta en línea</h1>
                        </div>
                        <div className="itemBase item50Left">
                            <span className="label">Nombre</span>
                            <input className="inputText" required value={name} onChange={(event) => { setName(event.target.value); }} type="text" />
                        </div>
                        <div className="itemBase item50Right">
                            <span className="label">Apellido</span>
                            <input className="inputText" required value={lastName} onChange={(event) => { setLastName(event.target.value); }} type="text" />
                        </div>
                        <div className="itemBase item100">
                            <span translate="no" className="label notranslate">RUT</span>
                            <input className="inputText" required value={RUT} onChange={(event) => {
                                if (validarRut(event.target.value) === false) {
                                    event.target.setCustomValidity("Introduce un RUT valido")
                                } else {
                                    event.target.setCustomValidity("");
                                }

                                setRUT(event.target.value);
                            }}
                                type="text" />
                        </div>
                        <div className="itemBase item100">
                            <span className="label">Correo electrónico</span>
                            <input className="inputText" required value={email} onChange={(event) => { setEmail(event.target.value); }} type="text" />
                        </div>
                        <div className="itemBase item100">
                            <span className="label">Telefono</span>
                            <input className="inputText" required value={cellphone} onChange={(event) => { setCellphone(event.target.value); }} type="text" />
                        </div>

                        <div className="separator"></div>

                        <div className="itemBase item100 noMargin">
                            <span className="label">Seleccione la categoría a la que pertenece</span>
                        </div>

                        <div className="itemBase item100 itemRow noMargin">
                            <input onChange={() => { SetRadioButtonOption(0); setSecondaryKey(""); }} checked={radioButtonOption === 0} className="itemRowElement0" type="radio" name="accountType" />
                            <span className="itemRowElement1 "> Soy pescador </span>
                            <input required={radioButtonOption === 0} value={radioButtonOption === 0 ? secondaryKey : ""} disabled={radioButtonOption !== 0} className={(radioButtonOption !== 0 ? "inputTextDisabled " : "") + "itemRowElement2 inputText notranslate"} placeholder="Ingrese su número de registro de pescador Artesanal (RPA)" onChange={(event) => { setSecondaryKey(event.target.value); }} type="text" />
                        </div>

                        <div className="itemBase item100 itemRow noMargin">
                            <input onChange={() => { SetRadioButtonOption(1); setSecondaryKey(""); }} checked={radioButtonOption === 1} className="itemRowElement0" type="radio" name="accountType" />
                            <span className="itemRowElement1 "> Soy comercializador de la caleta </span>
                            <input required={radioButtonOption === 1} value={radioButtonOption === 1 ? secondaryKey : ""} disabled={radioButtonOption !== 1} className={(radioButtonOption !== 1 ? "inputTextDisabled " : "") + "itemRowElement2 inputText notranslate"} placeholder="Ingrese su número de Registro Sernapesca" onChange={(event) => { setSecondaryKey(event.target.value); }} type="text" />
                        </div>

                        <div className="itemBase item100 itemRow noMargin">
                            <input onChange={() => { SetRadioButtonOption(2); setSecondaryKey(""); }} checked={radioButtonOption === 2} className="itemRowElement0" type="radio" name="accountType" />
                            <span className="itemRowElement1 "> Somos organización </span>
                            <input required={radioButtonOption === 2} value={radioButtonOption === 2 ? secondaryKey : ""} disabled={radioButtonOption !== 2} className={(radioButtonOption !== 2 ? "inputTextDisabled " : "") + "itemRowElement2 inputText notranslate"} placeholder="Ingrese su número de ROA" onChange={(event) => { setSecondaryKey(event.target.value); }} type="text" />
                        </div>

                        <div className="separator"></div>

                        <div className="itemBase item100">
                            <span className="label">Ingrese algún comentario</span>
                            <textarea className="inputText" required onChange={(event) => { setMessage(event.target.value); }} name="" id="" value={message} cols="30" rows="3"></textarea>
                        </div>
                        <div className="itemBase item100">
                            <input className="submitButton" type="submit" value="Enviar"></input>
                        </div>
                    </form>
                </div>
            </div>
        </Fragment>
    )
}

export default FormPage;